const vw = {
  appConfig: {
    brandName: 'vw',
    language: 'de-DE',
    isCarTypeSelectionEnabled: true
  }
};

export default vw;
